import { useNavigate } from 'react-router-dom';

import { Button } from '@/components';
import { TshirtTeam } from '@/components/TshirtTeam';
import useAuth from '@/hooks/useAuth';
import useTshirtAndShield from '@/hooks/useTshirtAndShield';
import ROUTES from '@/router/routes';
import { SelectedScreen } from '@/types/editProfile';

export const BoxTshirtEdit = ({
  position,
}: {
  position?: string | number | undefined;
}) => {
  const { userInitialData } = useAuth();
  const navigate = useNavigate();

  const { data: dataTshirtShield } = useTshirtAndShield();

  const handleModifyCBU = () => {
    navigate(ROUTES.editAccount.myCBU, {
      state: {
        returnPage: ROUTES.goldDate.list,
      } as SelectedScreen,
    });
  };

  return (
    <>
      <div className="bg-white rounded-lg lg:py-8 p-4 mt-4 lg:mt-0 flex">
        <div className="flex flex-1">
          <figure className="lg:w-[4.5rem] w-10">
            <TshirtTeam
              shield={dataTshirtShield?.shield}
              tshirt={dataTshirtShield?.tshirt}
              withShield={true}
            />
          </figure>
          <div className="lg:ml-7 ml-3">
            <p className="lg:text-lg text-sm font-bold text-gdt-gray">
              {userInitialData?.nombre_equipo}
            </p>
            <span className="text-gdt-gray-3 text-2xs lg:text-sm block lg:mt-2">
              DT {userInitialData?.nombre_dt}
            </span>
            <div className="lg:mt-2">
              <Button
                className="text-gdt-blue font-bold text-2xs lg:text-sm"
                type="button"
                variant="text"
                onClick={handleModifyCBU}
              >
                Modificar datos del CBU
              </Button>
            </div>
          </div>
        </div>
        {position && (
          <div className="text-left pr-4">
            <div className="">
              <p className="text-2xs">RANKING</p>
              <b
                className={`text-xl ${
                  Number(position) === 1
                    ? 'text-gdt-status-yellow'
                    : 'text-black'
                }`}
              >
                {position !== '-' ? `#${position}` : '-'}
              </b>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
